export enum OdometerType {
  Kilometers = 'kilometers',
  Miles = 'miles',
  Hours = 'hours',
  NoOdometer = 'no_odometer'
}
